"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @deckee/app-main
 * App main integration endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jason@deckee.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalMapSettingToJSON = exports.SignalMapSettingFromJSONTyped = exports.SignalMapSettingFromJSON = exports.SignalMapSetting = void 0;
/**
 *
 * @export
 */
exports.SignalMapSetting = {
    Anonymous: 'anonymous',
    Profile: 'profile',
    Invisible: 'invisible'
};
function SignalMapSettingFromJSON(json) {
    return SignalMapSettingFromJSONTyped(json, false);
}
exports.SignalMapSettingFromJSON = SignalMapSettingFromJSON;
function SignalMapSettingFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SignalMapSettingFromJSONTyped = SignalMapSettingFromJSONTyped;
function SignalMapSettingToJSON(value) {
    return value;
}
exports.SignalMapSettingToJSON = SignalMapSettingToJSON;
